import { FC } from "preact/compat";
import { NavLink } from "react-router-dom";
import { useApp } from "~/core";
import { useAccessCheck } from "~/hooks";
import { MenuItemProps } from "./interfaces";
import cn from "classnames";

const MenuItem: FC<MenuItemProps> = ({
    path,
    icon: Icon,
    label,
    access = [],
}) => {
    const { mobile } = useApp();
    const { isLoading, check } = useAccessCheck();
    const isSatisfied = check(access);

    if (isLoading || !isSatisfied) {
        return null;
    }

    return (
        <NavLink
            key={path}
            to={path}
            onClick={() => mobile.toggleMenuPage(false)}
            className={({ isActive }) =>
                cn(
                    "flex items-center rounded-3xl fill-current px-4 py-2",
                    isActive && "bg-zinc-600/30 border-2 border-zinc-600/10",
                )
            }
        >
            <Icon width="20" height="20" />
            <span className="ml-4 font-bold">{label}</span>
        </NavLink>
    );
};

export default MenuItem;
